import {useFeatureFlags} from "../../providers/FeatureFlagProvider/FeatureFlagProvider";

export const useIsBearingTempsTabEnabled = () : boolean => {
    const featureFlags = useFeatureFlags();
    return featureFlags.includes("isBearingTempsTabEnabled");
}